import React, { Component, cloneElement } from 'react';
import PropTypes from 'prop-types';
import { translate } from 'react-i18next';
import Modal from 'antd/lib/modal';
import { connectModal } from '../../../features/modal/hoc';
import { apiCallIds } from '../api';
import Select from 'antd/lib/select';


const { Option } = Select;
@translate()
@connectModal(apiCallIds.REJECT_LOAN)
export default class RejectLoanModal extends Component {
  static propTypes = {
    t: PropTypes.func.isRequired,
    modalActions: PropTypes.object.isRequired,
    isVisible: PropTypes.bool.isRequired,
    isLoading: PropTypes.bool.isRequired,
    onSubmit: PropTypes.func.isRequired,
    children: PropTypes.node.isRequired,
  };

  constructor(props) {
    super(props);

    this.state = {
      valueDrop: ""
    };
  }

  changedDrop = (val) => {
    this.setState({ valueDrop: val });
  }

  handleRejectModalConfirm = () => {
    if (this.state.valueDrop === "")
      return false;
    this.props.onSubmit(this.state.valueDrop);
  };

  render() {
    const { modalActions, isLoading, isVisible, t, children } = this.props;

    return (
      <span>
        {cloneElement(children, { onClick: modalActions.show })}
        <Modal
          title={t('Prajete si zamietnuť pôžičku?')}
          visible={isVisible}
          confirmLoading={isLoading}
          onOk={this.handleRejectModalConfirm}
          onCancel={modalActions.hide}
          okText={t('Zamietnuť')}
        >
          {t(
            'Pre zamietnutie pôžičky stlačte tlačidlo Zamietnuť. Zamietnutie pôžičky je nezvratné.'
          )}
          <Select
            placeholder={t('Vybrať dôvod')}
            onChange={this.changedDrop}
          >
            <Option value="Fraud (telefón nepatrí klientovi a klienta nepozná)">{t('Fraud (telefón nepatrí klientovi a klienta nepozná)')}</Option>
            <Option value="Nemá vlastný e-mail/telefón/účet">{t('Nemá vlastný e-mail/telefón/účet')}</Option>
            <Option value="Nízky príjem - ZAM/brigáda/dohoda/NEZ/SZCO">{t('Nízky príjem - ZAM/brigáda/dohoda/NEZ/SZCO')}</Option>
            <Option value="Nevie zdokladovať príjem">{t('Nevie zdokladovať príjem')}</Option>
            <Option value="Nedá sa skontaktovať">{t('Nedá sa skontaktovať')}</Option>
            <Option value="Rizikový">{t('Rizikový')}</Option>
            <Option value="Zahraničie">{t('Zahraničie')}</Option>
            <Option value="OP - odcudzený/stratený">{t('OP - odcudzený/stratený')}</Option>
            <Option value="OP - poškodený">{t('OP - poškodený')}</Option>
            <Option value="Rozpor v údajoch / klame">{t('Rozpor v údajoch / klame')}</Option>
            <Option value="Neplatič v rodine (na adrese)">{t('Neplatič v rodine (na adrese)')}</Option>
            <Option value="Klient už nemá záujem o pôžičku">{t('Klient už nemá záujem o pôžičku')}</Option>
            <Option value="Klient nevie pracovať s internetom">{t('Klient nevie pracovať s internetom')}</Option>
            <Option value="Klient nerozumie po slovensky">{t('Klient nerozumie po slovensky')}</Option>
            <Option value="Klient nesúhlasí s podmienkami úveru">{t('Klient nesúhlasí s podmienkami úveru')}</Option>
            <Option value="Nezaslal OP + DDT + POP">{t('Nezaslal OP + DDT + POP')}</Option>
            <Option value="Vysoká čiastka">{t('Vysoká čiastka')}</Option>
            <Option value="Prekročená doba schvaľovania - 3 dni">{t('Prekročená doba schvaľovania - 3 dni')}</Option>
            <Option value="Duplicita">{t('Duplicita')}</Option>
            <Option value="Iné - prechodný pobyt">{t('Iné - prechodný pobyt')}</Option>
            <Option value="Iné - potvrdenie na pobyt">{t('Iné - potvrdenie na pobyt')}</Option>
            <Option value="Iné">{t('Iné')}</Option>
            <Option value="Dočasne zamietnutý" > {t('Dočasne zamietnutý')}</Option>
          </Select>
        </Modal>
      </span>
    );
  }
}



// WEBPACK FOOTER //
// ./src/features/loan-management/components/RejectLoanModal.js